unit Search.MasterAccount;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client, VCL.TMSFNCCustomComponent,
  VCL.TMSFNCDataGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCDataGrid, Vcl.Controls, WEBLib.ExtCtrls;

type
  TfrmSearchMasterAccount = class(TWebForm)
    WebPanel1: TWebPanel;
    WebPanel2: TWebPanel;
    WebPanel3: TWebPanel;
    WebButton1: TWebButton;
    WebButton2: TWebButton;
    weSearch: TWebEdit;
    dgSearch: TTMSFNCDataGrid;
    dgdbaSearchPrinter: TTMSFNCDataGridDatabaseAdapter;
    wcSupplier: TXDataWebClient;
    wdsSupplier: TXDataWebDataSet;
    wdsSupplierCRNumber: TStringField;
    wdsSupplierCRName: TStringField;
    dsSupplier: TWebDataSource;
    procedure weSearchChange(Sender: TObject);
    procedure dgSearchCellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton2Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    sCRName, sCRNumber : String;
  end;

var
  frmSearchMasterAccount: TfrmSearchMasterAccount;

implementation

{$R *.dfm}

uses
  stfmssystem.connection ,  share.common;

procedure TfrmSearchMasterAccount.dgSearchCellClick(Sender: TObject; AColumn,
  ARow: Integer);
begin
  dgdbaSearchPrinter.SetActiveRecord(ARow);
  sCRNumber := dgdbaSearchPrinter.FieldAtColumn[0].AsString;
  sCRName := dgdbaSearchPrinter.FieldAtColumn[1].AsString;
end;

procedure TfrmSearchMasterAccount.WebButton1Click(Sender: TObject);
begin
  close;
end;

procedure TfrmSearchMasterAccount.WebButton2Click(Sender: TObject);
begin
  sCRName := '';
  sCRNumber := '';

  close;
end;

procedure TfrmSearchMasterAccount.WebFormShow(Sender: TObject);
  procedure OnResult(Response : TXDataClientResponse);
    begin
      wdsSupplier.Close;
      wdsSupplier.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      wdsSupplier.Open;
    end;
begin
  wcSupplier.RawInvoke('IstfmsdieselService.Get_MasterAccounts_View',[0,'*'],@OnResult);
end;

procedure TfrmSearchMasterAccount.weSearchChange(Sender: TObject);
begin
  if weSearch.Text <> '' then
    begin
      case dgSearch.Selection.StartCell.Column of
        0 : wdsSupplier.Locate('CRNumber', weSearch.Text, [loPartialKey]);
        1 : wdsSupplier.Locate('CRName', weSearch.Text, [loPartialKey]);
      end;
    end;
end;

end.